import React from 'react';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';

const TOOLBAR = [
  [{ header: [1, 2, 3, false] }],
  ['bold', 'italic', 'underline', 'strike'],
  [{ list: 'ordered' }, { list: 'bullet' }],
  [{ align: [] }],
  ['blockquote', 'code-block'],
  ['link', 'image'],
  [{ color: [] }, { background: [] }],
  ['clean'],
];

const FORMATS = [
  'header',
  'bold',
  'italic',
  'underline',
  'strike',
  'list',
  'bullet',
  'align',
  'blockquote',
  'code-block',
  'link',
  'image',
  'color',
  'background',
];

interface Props {
  value?: string;
  onChange?: (v: string) => void;
  placeholder?: string;
}

/**
 * AntD-friendly rich text editor wrapping react-quill-new. The HTML output
 * goes straight into Post.body[locale] in the backend; the mobile app must
 * render it via WebView or react-native-render-html (deferred).
 */
export function RichEditor({ value, onChange, placeholder }: Props): React.ReactElement {
  return (
    <div className="rich-editor-wrap">
      <ReactQuill
        theme="snow"
        value={value ?? ''}
        onChange={(html) => onChange?.(html === '<p><br></p>' ? '' : html)}
        modules={{ toolbar: TOOLBAR }}
        formats={FORMATS}
        placeholder={placeholder ?? 'Scrivi qui…'}
      />
      <style>{`
        .rich-editor-wrap .ql-toolbar.ql-snow,
        .rich-editor-wrap .ql-container.ql-snow {
          border-color: #d9d9d9;
        }
        .rich-editor-wrap .ql-toolbar.ql-snow {
          border-top-left-radius: 6px;
          border-top-right-radius: 6px;
          background: #fafafa;
        }
        .rich-editor-wrap .ql-container.ql-snow {
          border-bottom-left-radius: 6px;
          border-bottom-right-radius: 6px;
          min-height: 220px;
        }
        .rich-editor-wrap .ql-editor {
          min-height: 220px;
          font-size: 14px;
          line-height: 1.65;
        }
      `}</style>
    </div>
  );
}
